var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-logo-container"},[_c('img',{staticClass:"h-auto max-w-full w-[150px] sm:w-[200px]",attrs:{"title":_vm.$root.app.name,"src":_vm.$root.app.logo_url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }